import { render, staticRenderFns } from "./MarketReports.vue?vue&type=template&id=281acfbe&scoped=true&"
import script from "./MarketReports.vue?vue&type=script&lang=js&"
export * from "./MarketReports.vue?vue&type=script&lang=js&"
import style0 from "./MarketReports.vue?vue&type=style&index=0&id=281acfbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281acfbe",
  null
  
)

export default component.exports